import templates from '../core/templates';
import environment from '../environment';
import Leaflet from './Leaflet';

class BroadcastTVLayer {
    constructor (currentMap) {
        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            remote: {
                method: 'GET',
                url: `${environment.get('API_HOST')}/Layer/GetTvRepeater`,
                params: {
                    id: 1
                }
            },
            scaleRange: [8, 20],
            showAll: false,
            // autofocus: false
            uniqueField: 'IdRepetidora',
            sort: 'Nome',
            label: {
                template (properties) {
                    return templates('map-layer-tvstations-label', properties);
                }
            },
            symbology: {
                type: 'single',
                style: {
                    lineJoin: 'round',
                    color: '#2980b9',
                    fillColor: '#3498db',
                    fillOpacity: 0.15,
                    opacity: 1,
                    weight: 2
                }
            }
        });
    }
}

export default BroadcastTVLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/BroadcastTVLayer.js